@if (credits.isOpen()) {
  <div
    class="credits-overlay"
    (click)="credits.close()"
    (keydown)="onKeydown($event)"
    tabindex="0"
  >
    <div class="credits-modal" (click)="$event.stopPropagation()">
      <button
        type="button"
        class="credits-modal__close"
        (click)="credits.close()"
        aria-label="Chiudi"
      >
        ✕
      </button>

      <header class="credits-modal__header">
        <div class="credits-modal__eyebrow">Made with 🖤 by</div>
        <h2 class="credits-modal__title">Il team dietro Diakonix</h2>
        <p class="credits-modal__subtitle">
          Le persone che lo hanno costruito, tenuto vivo e lo migliorano ogni giorno.
        </p>
      </header>

      <div class="credits-modal__grid">
        @for (member of team; track member.name) {
           <article class="credits-card" [attr.data-variant]="member.roles[0].variant">
            <!--@if (member.maintainer) {
              <span class="credits-card__badge" title="Maintainer attivo">
                ⭐ Maintainer
              </span>
            }-->
            <div class="credits-card__avatar" [style.background]="getAvatarGradient(member)">
              {{ initials(member.name) }}
            </div>
            <div class="credits-card__name">
              {{ member.name }}
            </div>
            <div class="credits-card__roles">
              @for (role of member.roles; track role.label) {
                <span
                  class="credits-card__role"
                  [attr.data-variant]="role.variant"
                >
                  {{ role.label }}
                </span>
              }
            </div>
            <div class="credits-card__since">
              dal {{ member.since }}
            </div>
          </article>
        }
      </div>

      <footer class="credits-modal__footer">
        <div class="credits-modal__copyright">
          © {{ inceptionYear }}–{{ currentYear }} · Diakonix
        </div>
        <div class="credits-modal__tagline">
          Built by Connecta.
        </div>
      </footer>
    </div>
  </div>
}
